import { useState } from 'react';

const useTableMenu = <T>() => {
    const [selected, setSelected] = useState<T | null>(null);
    const [selectedItemFromAction, setSelectedItemFromAction] = useState<T | null>(null);

    const [openCard, setOpenCard] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const handleOpenCard = () => setOpenCard(true);
    const handleCloseCard = () => setOpenCard(false);

    const anchorToEventElement = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => setMenuOpen(false);
    const openMenu = () => setMenuOpen(true);

    const handleRowClick = (selectedRowItem: T) => {
        setSelected(selectedRowItem);
        handleOpenCard();
    };

    const handleClickAction = (event: React.MouseEvent<HTMLElement>, item: T, _index?: number) => {
        setSelectedItemFromAction(item);
        setSelected(item);
        anchorToEventElement(event);
        openMenu();
    };

    const handleSeeDetailsClick = () => {
        setSelected(selectedItemFromAction);
        handleOpenCard();
        closeMenu();
    };

    return {
        handleOpenCard,
        handleCloseCard,
        anchorToEventElement,
        closeMenu,
        openMenu,
        handleRowClick,
        handleClickAction,
        handleSeeDetailsClick,
        selected,
        selectedItemFromAction,
        openCard,
        anchorEl,
        menuOpen
    };
};

export default useTableMenu;
